import styled from 'styled-components';

export const PricingCompareStyled = styled.div`
  width: 100%;
`;

export const ContainerStyled = styled.div`
  max-width: 1300px;
  margin: 0 auto;
  padding: 30px 18.5px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  justify-content: center;
  align-items: center;

  .main-text {
    display: flex;
    flex-direction: column;
    gap: 14px;
    text-align: center;

    & .head-text {
      font-size: 18px;
      line-height: 32px;
      font-weight: 600;
      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        font-size: 24px;
        line-height: 45px;
      }
    }

    & .main-desc {
      font-weight: 500;
      font-size: 14px;
      line-height: 25px;
      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        font-size: 16px;
        line-height: 28px;
      }
      @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
        font-size: 16px;
        line-height: 20px;
      }
    }
  }
`;
